import React, { useEffect } from "react";
import styles from "./ContactUs.module.css";

import Contact from "../../components/Contact";

const ContactUs = () => {
  useEffect(() => {
    document.title = "Contact Us - The Records Hub S.A.";
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.titleContainer}></div>
      <Contact />
      <div className={styles.titleContainer}></div>
    </div>
  );
};

export default ContactUs;
